import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Projects from './pages/Projects';
import ScenarioEditor from './pages/ScenarioEditor';
import ProjectAnalysis from './pages/ProjectAnalysis';
import { AcDcSystemsTab } from './components/acdc';

/**
 * Site DNA App - Solar + Battery + Microgrid Modeling
 *
 * Main entry point for Site DNA functionality.
 * Handles routing for projects, scenario editing, and AC/DC systems.
 */
function SiteDNAApp() {
  return (
    <Routes>
      <Route path="/" element={<Projects />} />
      <Route path="/:projectId/analysis" element={<ProjectAnalysis />} />
      <Route path="/:projectId/acdc" element={<AcDcSystemsTab />} />
      <Route path="/:projectId/scenarios/:scenarioId" element={<ScenarioEditor />} />
    </Routes>
  );
}

export default SiteDNAApp;
